export default __webpack_public_path__ + "8a9b9c2c044f8ff8dfe70ef449f2224f.svg";